import SectionHeader from "../SectionHeader";
import { FaPenFancy, FaCalendarAlt } from "react-icons/fa";

export default function LatestBlog(props) {
  return (
    <>
      <SectionHeader>Latest Blog</SectionHeader>
      <div className="mx-auto max-w-5xl flex justify-between font-fontOne text-text">
        <Card img={require("../../assets/home/latest-blog/img01.png")} />
        <Card img={require("../../assets/home/latest-blog/img02.png")} />
        <Card img={require("../../assets/home/latest-blog/img03.png")} />
      </div>
    </>
  );
}

function Card({ img }) {
  return (
    <div className="group">
      {/* image container */}
      <div className=" bg-slate-300 overflow-hidden h-52 w-[20rem] flex justify-center items-center rounded-md">
        <img alt="" src={img} />
      </div>
      {/* text container */}
      <div className="mt-3 px-4 text-sm h-30 ">
        <div className="flex ">
          <div className="flex mr-8">
            <FaPenFancy className="mr-2 text-pink translate-y-[0.15rem]" />
            Saber Ali
          </div>
          <div className="flex">
            <FaCalendarAlt className="  mr-2 text-yellow-400 translate-y-[0.15rem]" />
            21 August 2021
          </div>
        </div>
        <h4 className="font-bold my-3 mb-2 group-hover:text-pink max-h-10 overflow-clip">
          Top essential Trends in 2021
        </h4>
        <p className="text-[#72718f] mb-3 font-fontTwo max-h-16 overflow-hidden">
          More off this less hellow samlande lied much over tightly cicra horse
          taped mighty.
        </p>
        <a className=" group-hover:text-pink border-b border-text" href="/">
          Read More
        </a>
      </div>
    </div>
  );
}
